import React, { useState } from "react";
import Style from "./examAnchor.module.scss";

import { Anchor } from "antd";
import { getExamTypeString } from "pages/homework/utils/filter";

const { Link } = Anchor;

interface IExamAnchorProps {
    list: {
        topicType: string;
        list: any[];
    }[];
}

const ExamAnchor = ({ list }: IExamAnchorProps) => {
    let [currentAnchor, setCurrentAnchor] = useState("");

    return (
        <div className={Style.main}>
            <p>题型：</p>
            <Anchor onChange={setCurrentAnchor}>
                {list.map(item => (
                    <Link
                        key={item.topicType}
                        href={`#${item.topicType}`}
                        title={
                            <div
                                className={`${Style.item} ${
                                    currentAnchor === `#${item.topicType}`
                                        ? Style.active
                                        : ""
                                }`}>
                                {getExamTypeString(item.topicType)}题
                                <span>{item.list.length} 题</span>
                            </div>
                        }
                    />
                ))}
            </Anchor>
        </div>
    );
};

export default ExamAnchor;
